import * as I18n from 'circe/I18n';
import { NAME as APP_NAME, ROUTES as VEHICLES_ROUTES } from 'domain/vehicle/constants';

export const NAME = `${APP_NAME}/VEHICLES`;

export const REDUCER_NAME = 'vehicles';

export const FORM_NAME = 'UPDATE_VEHICLE_INFO';

export const ROUTES = {
  ROOT: `${VEHICLES_ROUTES.ROOT}/:vehicleId/update`,
};
